import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import ErrorPage from '@/pages/error';

function ErrorBoundaryFallback({ error }: FallbackProps) {
  const statusCode = `${error}`.includes('NOT_FOUND') ? 404 : 500;

  return <ErrorPage statusCode={statusCode} />;
}

export default ErrorBoundaryFallback;
